export const remSize = parseFloat(getComputedStyle(document.body).fontSize);
